// extracted by mini-css-extract-plugin
module.exports = {"headerMenu":"styles_headerMenu__WnerB","isReverse":"styles_isReverse__voDav"};